import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { SubtitleSurveyLabel } from "theme/survey";
import { DivCheckbox, PCheckbox, Checkbox } from "theme/theme";
import { Options } from "views/raffles/types";

export interface CheckBoxProps {
  title: string;
  items?: Options[];
  onChange: (key: string, selected: string[]) => void;
}

function CheckboxMapper(props: CheckBoxProps) {
  const [selected, setSelected] = useState<string[]>([]);
  const titleRef = useRef<HTMLHeadingElement>(null);

  const onClick: MouseEventHandler<HTMLDivElement> = (event) => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'SURVEY - Seleccionar encuesta', value: '10' })
    const itemId = event.currentTarget.id as string;
    if (selected.includes(itemId)) {
      return setSelected(selected.filter((item) => item !== itemId));
    }
    return setSelected((state) => [...state, itemId]);
  };

  useEffect(() => {
    props.onChange(titleRef.current?.innerText.replace("\n", " ").toLocaleLowerCase() || "", selected);
  }, [selected, titleRef]);

  return (
    <>
      <div className="p-2 w-full">
        <SubtitleSurveyLabel className="font-black text-2xl text-center md:text-3xl" ref={titleRef}>
          {props.title}
        </SubtitleSurveyLabel>
      </div>
      <div className={`flex flex-col justify-center my-2 gap-4 md:mx-auto w-full text-black`}>
        {props.items &&
          props.items.map(({ id, option }) => {
            const key = `${id}`;
            const isSelected = selected.includes(key);

            return (
              <DivCheckbox className="gap-4 flex items-center cursor-pointer" onClick={onClick} key={key} id={key}>
                <Checkbox className={`h-6 w-6 flex items-center justify-center`} id="suscribe" active={isSelected} />
                <PCheckbox className="dinPro">{option}</PCheckbox>
              </DivCheckbox>
            );
          })}
      </div>
    </>
  );
};

export default CheckboxMapper